// Utils
import cntl from "cntl";
import PropTypes from "prop-types";
import { MODAL_FOOTER_VARIANTS } from "../../constants";

// Components
import ModalFooterLink from "@dbox/components/molecules/modal/ModalFooterLink";
import ModalFooterDefault from "@dbox/components/molecules/modal/ModalFooterDefault";
import ModalFooterAuxiliary from "@dbox/components/molecules/modal/ModalFooterAuxiliary";
import ModalFooterDestructive from "@dbox/components/molecules/modal/ModalFooterDestructive";

const FooterVariant = {
  [MODAL_FOOTER_VARIANTS.link]: ModalFooterLink,
  [MODAL_FOOTER_VARIANTS.default]: ModalFooterDefault,
  [MODAL_FOOTER_VARIANTS.destructive]: ModalFooterDestructive,
  [MODAL_FOOTER_VARIANTS.auxiliary_actions]: ModalFooterAuxiliary,
};

const propTypes = {
  hasDivider: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    MODAL_FOOTER_VARIANTS.link,
    MODAL_FOOTER_VARIANTS.default,
    MODAL_FOOTER_VARIANTS.destructive,
    MODAL_FOOTER_VARIANTS.auxiliary_actions,
  ]),
};

function ModalFooter({ className, hasDivider = false, variant = MODAL_FOOTER_VARIANTS.default, ...props }) {
  const footerCn = () => cntl`
    ${hasDivider ? "p-4 border-t border-t-gray-light-4 dark:border-t-gray-dark-4" : "p-4 pt-0"}
    ${className ? className : undefined}
  `;

  const FooterComponent = FooterVariant[variant];

  return (
    <div className={footerCn()}>
      <FooterComponent {...props} />
    </div>
  );
}

ModalFooter.propTypes = propTypes;
export default ModalFooter;
